export default __webpack_public_path__ + "static/media/St. Patrick_s Day luck.bb909a40.jpg";